import { render, staticRenderFns } from "./OrderStateCardComponent.vue?vue&type=template&id=6e8ede24&"
import script from "./OrderStateCardComponent.vue?vue&type=script&lang=js&"
export * from "./OrderStateCardComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports